import { render, staticRenderFns } from "./LmDocumentTypeNumber.vue?vue&type=template&id=6f2e5ceb&scoped=true"
import script from "./LmDocumentTypeNumber.vue?vue&type=script&lang=js"
export * from "./LmDocumentTypeNumber.vue?vue&type=script&lang=js"
import style0 from "./LmDocumentTypeNumber.vue?vue&type=style&index=0&id=6f2e5ceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e5ceb",
  null
  
)

export default component.exports